import { useEffect, useState } from "react";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "@/lib/firebase";
import type { Availability } from "@/lib/types";

export function useAvailability(clubId: string | undefined, matchId: string | undefined) {
  const [responses, setResponses] = useState<(Availability & { id: string })[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clubId || !matchId) {
      setResponses([]);
      setLoading(false);
      return;
    }

    const q = query(
      collection(db, "clubs", clubId, "matches", matchId, "availability"),
      orderBy("respondedAt", "desc")
    );

    const unsub = onSnapshot(q, (snap) => {
      setResponses(
        snap.docs.map((d) => ({ id: d.id, ...d.data() })) as (Availability & { id: string })[]
      );
      setLoading(false);
    });

    return unsub;
  }, [clubId, matchId]);

  const available = responses.filter((r) => r.status === "available");
  const unavailable = responses.filter((r) => r.status === "unavailable");
  const maybe = responses.filter((r) => r.status === "maybe");
  const myResponse = (userId: string) => responses.find((r) => r.userId === userId);

  return { responses, available, unavailable, maybe, myResponse, loading };
}
